import React from 'react' ;
import NavBar from '../layoutcomponents/NavBar';
import Abpic from './Abpic';


const Aboutus = ()=>{
return(
    <div>
      <NavBar/>
        <Abpic/>
    </div>
)
}

export default Aboutus;
